import { TextField, TextareaField, NumberField, CurrencyField, DateField } from "./TextFields";
import { SelectField, MultiselectField, RadioField, BooleanField } from "./ChoiceFields";
import { FileField } from "./FileField";
import type { FieldControlProps } from "./FieldShell";

/** Dispatcher: renderiza o controle certo conforme o tipo do campo. */
export function FieldControl(props: FieldControlProps) {
  switch (props.field.field_type) {
    case "text":
    case "email":
    case "phone":
      return <TextField {...props} />;
    case "textarea":
      return <TextareaField {...props} />;
    case "number":
      return <NumberField {...props} />;
    case "currency":
      return <CurrencyField {...props} />;
    case "date":
      return <DateField {...props} />;
    case "select":
      return <SelectField {...props} />;
    case "multiselect":
      return <MultiselectField {...props} />;
    case "radio":
      return <RadioField {...props} />;
    case "boolean":
      return <BooleanField {...props} />;
    case "file":
      return <FileField {...props} />;
    default:
      return null;
  }
}